import mathUtils from './mathUtils';

export const calculateAmountByExchangeRate = (
  amount: number | string,
  exchangeRate?: number | string | null,
) => mathUtils.round(mathUtils.divide(amount, exchangeRate || 1));
